import type { ProDataDeletionInput, ProDataDeletionResult, ProMeDto } from "dutyon-server/types";
import { useAuthStore } from "../auth/authStore";
import { httpClient } from "./httpClient";
import { proSupportRequestConfig } from "./pro-support-session";

/** Preserve the initiating account; never refresh/replay deletion under a different account. */
export async function requestProDataDeletionForOwner(
  owner: string,
  input: ProDataDeletionInput,
): Promise<ProDataDeletionResult> {
  const config = proSupportRequestConfig(useAuthStore.getState(), owner);
  return (await httpClient.post<ProDataDeletionResult>("/pro/workspace/deletion", input, config))
    .data;
}
export async function getProMeForOwner(owner: string): Promise<ProMeDto> {
  const config = proSupportRequestConfig(useAuthStore.getState(), owner);
  return (await httpClient.get<ProMeDto>("/pro/me", config)).data;
}

export async function getProAdminDataDeletionRequests(
  owner: string,
  filters: import("dutyon-server/types").ProAdminDataDeletionQuery = {},
): Promise<import("dutyon-server/types").ProAdminDataDeletionListDto> {
  const state = useAuthStore.getState();
  const config = proSupportRequestConfig(state, owner);
  if (state.user?.role !== "SUPER_ADMIN") throw new Error("최고 관리자만 조회할 수 있습니다.");
  return (
    await httpClient.get<import("dutyon-server/types").ProAdminDataDeletionListDto>(
      "/admin/pro/data-deletion-requests",
      { ...config, params: filters },
    )
  ).data;
}
